import { render, staticRenderFns } from "./ad-account-item.vue?vue&type=template&id=5a083b8e&scoped=true&"
import script from "./ad-account-item.vue?vue&type=script&lang=js&"
export * from "./ad-account-item.vue?vue&type=script&lang=js&"
import style0 from "./ad-account-item.vue?vue&type=style&index=0&id=5a083b8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a083b8e",
  null
  
)

export default component.exports